function state() {
  return {
    commercialLines: [],
    commercialLinesMeta: {},
    quickViews: [],
    commercialLine: {},
    listProductCategory: [],
  };
}

export default state;
